interface SubMenu {
	title?: string;
	path?: string;
}
export interface MenuList {
	mainMenu: string;
	subMenu?: SubMenu[];
	mainPath?: string;
}

export interface MypageMenuList {
	menu: string;
	path: string;
}
export const menuList: MenuList[] = [
	{
		mainMenu: 'Home',
		mainPath: '/',
		// subMenu: [
		// 	{
		// 		title: '인사말',
		// 		path: '/introduce',
		// 	},
		// 	{
		// 		title: '학회연혁',
		// 		path: '/introduce',
		// 	},
		// 	{
		// 		title: '임원 및 위원회',
		// 		path: '/introduce',
		// 	},
		// 	{
		// 		title: '학회회칙',
		// 		path: '/introduce',
		// 	},
		// ],
	},
	{
		mainMenu: 'Team',
		mainPath: 'team',
		// subMenu: [
		// 	{
		// 		title: '회원가입 안내',
		// 		path: '/membership',
		// 	},
		// 	{
		// 		title: '회원가입',
		// 		path: '/membership',
		// 	},
		// 	{
		// 		title: '회비안내',
		// 		path: '/membership',
		// 	},
		// 	{
		// 		title: '연회비 납부',
		// 		path: '/membership',
		// 	},
		// ],
	},
	// {
	// 	mainMenu: '학술대회',
	// 	mainPath: '',
	// 	subMenu: [
	// 		{
	// 			title: '학술대회 안내',
	// 			path: '/conference',
	// 		},
	// 		{
	// 			title: '지난 학술대회',
	// 			path: '/conference',
	// 		},
	// 	],
	// },
	{
		mainMenu: 'Portfolio',
		mainPath: 'portfolio',
		subMenu: [],
	},
	{
		mainMenu: 'News',
		mainPath: 'infoplace',
		// subMenu: [
		// 	{
		// 		title: '공지사항',
		// 		path: '/infoplace',
		// 	},
		// 	{
		// 		title: '소식지',
		// 		path: '/infoplace',
		// 	},
		// 	{
		// 		title: '연구동향',
		// 		path: '/infoplace',
		// 	},
		// 	{
		// 		title: '갤러리',
		// 		path: '/infoplace',
		// 	},
		// ],
	},
];

export const mypageMenuList: MypageMenuList[] = [
	{
		menu: '기본정보',
		path: '/mypage/basic',
	},
	{ menu: '직장정보', path: '/mypage/company' },
	{ menu: '학력정보', path: '/mypage/education' },
	{ menu: '기타정보', path: '/mypage/etc' },
	{ menu: '비밀번호 변경', path: '/mypage/password' },
	{ menu: '서비스 이용약관', path: '/mypage/term/service' },
	{ menu: '개인정보 처리방침', path: '/mypage/term/privacy' },
];

export const CONF_TITLE = '2025년 타이키파트너스 춘계학술대회';
export const CONF_TITLE_MAIN = '2025년 타이키파트너스\n춘계학술대회';
